import mixpanel from "mixpanel-browser";

const token = process.env.REACT_APP_MIXPANEL_TOKEN;
const apiHost =
  process.env.REACT_APP_MIXPANEL_API_HOST || "https://api.mixpanel.com";
const isProd = process.env.NODE_ENV === "production";

let initialized = false;
let loggedDevSkip = false;

export const initMixpanel = () => {
  if (initialized) {
    console.info("Mixpanel init skipped; already initialized");
    return;
  }

  if (!isProd) {
    if (!loggedDevSkip) {
      console.info("Mixpanel init skipped; non-production environment");
      loggedDevSkip = true;
    }
    return;
  }

  if (!token) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Mixpanel token missing; analytics disabled");
    }
    return;
  }

  mixpanel.init(token, {
    api_host: apiHost,
  });

  console.info("Mixpanel initialized", { apiHost });
  initialized = true;
};

const ensureInit = () => {
  if (!initialized) {
    initMixpanel();
  }
  return initialized;
};

export const trackEvent = (event: string, props?: Record<string, unknown>) => {
  if (!ensureInit()) return;
  mixpanel.track(event, props);
};

export const trackPageView = (path: string) => {
  trackEvent("Page View", { path });
};

export const identifyUser = (id: string) => {
  if (!id) return;
  if (!ensureInit()) return;
  mixpanel.identify(id);
};

export const resetMixpanel = () => {
  if (!initialized) return;
  mixpanel.reset();
  initialized = false;
};
